import { BASE_API_URL } from '@env';
import { Notifier, NotifierComponents } from 'react-native-notifier';
import { useMutation, useQueryClient } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';

interface IAddUserEventStatus {
  event_id: string;
}
export function useAddUserListPayPerMatch() {

  return useMutation<boolean | undefined, Error, IAddUserEventStatus>(
    async (requestData: IAddUserEventStatus) => {
      const token = useUserStore.getState().token;
      const { event_id } = requestData;
      const response = await fetch(`${BASE_API_URL}events/${event_id}/match`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        try {
          const errorResponse: any = await response.json();
          console.log(errorResponse, 'errorResponse.detail');
        } catch (error) { }
        throw new Error('Failed to change user status');
      }
      return response.json();
    },
    {
      onSuccess: () => {
      },
    },
  );
}
